import { gql } from "@apollo/client";

export const GET_INFO_EVALUATION_PERFORMANCE_BY_ID = gql`
query GET_INFO_EVALUATION_PERFORMANCE_BY_ID($idPerEval: ID!) {
    GET_INFO_EVALUATION_PERFORMANCE_BY_ID(idPerEval: $idPerEval) {
    DateEnd
    DateInit
    description
    id
    namePerformance
    tipoEvaluacion
  }
  }
`;

export const GET_INFO_USER_BY_ID_PERFORMANCE_EVAL = gql`
query GET_INFO_USER_BY_ID_PERFORMANCE_EVAL($idUser: ID!,$idPerEval:ID!) {
  GET_INFO_USER_BY_ID_PERFORMANCE_EVAL(idUser: $idUser, idPerEval:$idPerEval) {
    idUser
    fullName
    email
    campus
    project
    dateAdmission
    idTypeEvaluation
    evaluatorResults {
      pesoAuto
      pesoLider
      pesoColega
      pesoSubordinado
      pesoCliente
      typeEval
      result
      sum
      count
      minReqSum
    }
    infoByCompetence {
      nameCompetence
      DescriptionCompetence
      idCompetencies
      infoEvalByCompetence {
        pesoAuto
        pesoLider
        pesoColega
        pesoSubordinado
        pesoCliente
        typeEval
        calEsperada
        result
        minReq
        caliForWeightByCompetence
        CalificationByCompetence
        desviacionByCompetence
        nivel
        estado
      }
    }
  }
  }
`;

export const GET_INFO_USER_BY_LEADER_PERFORMANCE_EVAL = gql`
query GET_INFO_USER_BY_LEADER_PERFORMANCE_EVAL($idUser: ID!, $idPerEval: ID!) {
  GET_INFO_USER_BY_LEADER_PERFORMANCE_EVAL(idUser: $idUser, idPerEval: $idPerEval) {
    id
    bussinesName
    email
    tipoEvaluacion
  }
  }
`;

export const GET_INFO_USER_BY_ADMIN_PERFORMANCE_EVAL = gql`
query GET_INFO_USER_BY_ADMIN_PERFORMANCE_EVAL($idPerEval: ID!) {
  GET_INFO_USER_BY_ADMIN_PERFORMANCE_EVAL( idPerEval: $idPerEval) {
    id
    bussinesName
    email
    tipoEvaluacion
  }
  }
`;

export const SEND_URL_EMAIL_RESULTS_COLLABORATOR = gql`
mutation SEND_URL_EMAIL_RESULTS_COLLABORATOR($idUser: ID!, $idPerEval: ID!) {
  SEND_URL_EMAIL_RESULTS_COLLABORATOR(idUser: $idUser, idPerEval: $idPerEval)
}
`;

